import { configureStore, isImmutableDefault } from '@reduxjs/toolkit';

import { operacaoReducer } from 'store/modules/operacoes/registro';
import { routerSlice } from 'store/modules/router';
import { participanteReducer } from 'store/modules/participantes/registro';
import { loaderSlice } from 'store/modules/loader';
import { authReducer } from 'store/modules/auth';
import { snackBarReducer } from './modules/snackBar';
import { investidorReducer } from './modules/investidores/registro';
import { cdcaApiReducer } from './modules/apis/cdca';
import { cotasDeFundoApiReducer } from './modules/apis/cotasDeFundo';
import { craApiReducer } from './modules/apis/cra';
import { criApiReducer } from './modules/apis/cri';
import { debentureApiReducer } from './modules/apis/debenture';
import { notaComercialApiReducer } from './modules/apis/notaComercial';
import { certificadoRecebiveisApiReducer } from './modules/apis/certificadoRecebiveis';
import { usuarioApiReducer } from './modules/apis/usuario';
import { investidorApiReducer } from './modules/apis/investidor';
import { registroApiReducer } from './modules/apis/registro';
import { participanteApiReducer } from './modules/apis/participante';
import { operacaoApiReducer } from './modules/apis/operacao';
import { catalogoApiReducer } from './modules/apis/catalogo';
import { instrumentoApiReducer } from './modules/apis/instrumentos';
import { instrumentoEdicaoApiReducer } from './modules/apis/instrumentoEdicao';
import cdcaCadastro from 'store/modules/cdca';
import cotasDeFundoCadastro from 'store/modules/cotasDeFundo';
import craCadastro from 'store/modules/cra';
import criCadastro from 'store/modules/cri';
import debentureCadastro from 'store/modules/debenture';
import notaComercialCadastro from 'store/modules/notaComercial';
import certificadoRecebiveisCadastro from 'store/modules/certificadoRecebiveis';
import { credenciadoApiReducer } from './modules/apis/credenciado';
import { aditamentoApiReducer } from './modules/apis/aditamento';
import { parametrizacaoApiReducer } from './modules/apis/parametrizacoes';
import { notaComercialByFileApiReducer } from './modules/apis/notaComercialByFile';
import { liquidacoesApiReducer } from './modules/apis/liquidacoes';
import { feriadosNacionaisReducer } from './modules/feriadosNacionais/feriadosNacionais';
import novoCadastroMovimentacaoReducer from './modules/novoCadastroMovimentacao';
import coordenadoresReducer from './modules/coordenadores';
import { notificacaoApiReducer } from './modules/apis/notificacao';
import { motorRiscosApiReducer } from './modules/apis/motorRiscos';

const isImmutable = (value: any) => isImmutableDefault(value) || value instanceof File;

const store = configureStore({
  reducer: {
    cdcaCadastro: cdcaCadastro,
    cotasDeFundoCadastro: cotasDeFundoCadastro,
    craCadastro: craCadastro,
    criCadastro: criCadastro,
    debentureCadastro: debentureCadastro,
    notaComercialCadastro: notaComercialCadastro,
    certificadoRecebiveisCadastro: certificadoRecebiveisCadastro,
    router: routerSlice.reducer,
    loader: loaderSlice.reducer,
    participante: participanteReducer,
    auth: authReducer,
    snackBar: snackBarReducer,
    investidor: investidorReducer,
    operacao: operacaoReducer,
    cdcaApi: cdcaApiReducer,
    cotasDeFundoApi: cotasDeFundoApiReducer,
    craApi: craApiReducer,
    criApi: criApiReducer,
    debentureApi: debentureApiReducer,
    notaComercialApi: notaComercialApiReducer,
    certificadoRecebiveisApi: certificadoRecebiveisApiReducer,
    usuarioApi: usuarioApiReducer,
    investidorApi: investidorApiReducer,
    registroApi: registroApiReducer,
    participanteApi: participanteApiReducer,
    operacaoApi: operacaoApiReducer,
    catalogoApi: catalogoApiReducer,
    instrumentoApi: instrumentoApiReducer,
    instrumentoEdicaoApi: instrumentoEdicaoApiReducer,
    credenciadoApi: credenciadoApiReducer,
    aditamentosApi: aditamentoApiReducer,
    parametrizacaoApi: parametrizacaoApiReducer,
    notaComercialByFileApi: notaComercialByFileApiReducer,
    liquidacoesApi: liquidacoesApiReducer,
    feriadosNacionais: feriadosNacionaisReducer,
    cadastroMovimentacao: novoCadastroMovimentacaoReducer,
    coordenadoresApi: coordenadoresReducer,
    notificacaoApi: notificacaoApiReducer,
    motorRiscosApi: motorRiscosApiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: {
        isImmutable: isImmutable,
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
